/*!
 * PatternFly Elements: PlccTable 2.1.10
 * @license
 * Copyright 2020 Red Hat, Inc.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * 
*/

import PFElement from "../../../@patternfly/pfelement/dist/pfelement.umd";
import "../../../@patternfly/pfe-progress-indicator/dist/pfe-progress-indicator.umd";
import "../../../@patternfly/pfe-datetime/dist/pfe-datetime.umd";
import {
  FULL_SUPPORT,
  MAINTENANCE_SUPPORT,
  EXTENDED_SUPPORT,
  END_OF_MAINTENANCE,
  END_OF_LIFE,
  UNCATEGORIZED,
  FULL_SUPPORT_ClASS,
  MAINTENANCE_SUPPORT_CLASS,
  EXTENDED_SUPPORT_CLASS,
  END_OF_LIFE_CLASS,
  END_OF_MAINTENANCE_CLASS,
} from "./constant.js";
class PlccTable extends PFElement {
  static get version() {
    return "2.1.10";
  }

  get html() {
    return `<style>.sr-only{opacity:0}.product-lifecycle-info__table thead{overflow:hidden;clip:rect(0,0,0,0);margin:-1px;padding:0;border:0}.product-lifecycle-info__table thead tr th{padding-top:0;padding-bottom:0}:host{display:block}:host([hidden]){display:none}:host([loading]) article{display:none}article{display:block;font-size:16px;line-height:1.5;color:#151515}#loading{justify-content:center;align-items:center;min-height:100px}#loading.loading{display:flex}.u-no-break{white-space:nowrap}*{box-sizing:border-box}.icon-close{position:relative;width:1.5em;height:1.5em;margin:0;padding:0;border:0;font-size:2rem;background:0 0;-webkit-appearance:none;-moz-appearance:none;appearance:none}.icon-close__inner1{position:absolute;top:50%;left:50%;width:0;height:0;font-size:4rem;transform:translate(-50%,-50%) scale(.125)}.icon-close__inner1:after,.icon-close__inner1:before{content:"";position:absolute;top:0;left:0;display:block;width:.3em;height:2em;background:#000}.icon-close:focus .icon-close__inner1:after,.icon-close:focus .icon-close__inner1:before,.icon-close:hover .icon-close__inner1:after,.icon-close:hover .icon-close__inner1:before{background:#06c}.icon-close__inner1:before{transform:translate(-50%,-50%) rotate(-45deg)}.icon-close__inner1:after{transform:translate(-50%,-50%) rotate(45deg)}article{font-size:1rem;line-height:1.5;color:#151515}.product-lifecycle__wrapper{position:relative}.product-lifecycle__wrapper--listing{border:1px solid #d2d2d2}.product-lifecycle__header{padding:1.125rem}@media (min-width:650px){.product-lifecycle__header{display:flex;align-items:baseline;flex-wrap:wrap;padding:1rem}}.product-lifecycle__header--more-info{display:flex;flex-direction:column}@media (min-width:1080px){.product-lifecycle__header--more-info{flex-direction:row}}.product-lifecycle__header--more-info>*{margin-bottom:.5em}@media (min-width:1080px){.product-lifecycle__header--more-info>*{margin-right:1.5rem}}.product-lifecycle__header--more-info>:last-child{margin-right:0}.product-lifecycle-info__product-name{font-size:1.25em;font-weight:400;width:100%}.product-lifecycle__header--less-info .product-lifecycle-info__product-name{margin-right:auto;width:auto}.product-lifecycle-info__detailed-info{margin-right:auto}.product-lifecycle__header--more-info .product-lifecycle-info__detailed-info{margin-bottom:1em}[type=checkbox]{margin-right:.25em}.product-lifecycle__close{position:absolute;top:0;right:0;cursor:pointer}table{min-width:100%;border:0}@media (min-width:650px){table{position:relative;margin-left:0;margin-right:0}}.product-lifecycle-info__table-headers{position:sticky;top:0;z-index:999;background:#fff}@media (min-width:1000px){.product-lifecycle-info__table-headers{display:table}}.product-lifecycle-info__table{border-top:0}.product-lifecycle-info__table .category td{border-bottom:3px solid #d2d2d2}caption,td,th{padding:1.125rem;border:0;text-align:left}caption *,td *,th *{margin:0;padding:0}th{font-weight:700;vertical-align:middle}@media (min-width:1000px){td:nth-last-child(2):first-child~td,td:nth-last-child(2):first-child~th,th:nth-last-child(2):first-child~td,th:nth-last-child(2):first-child~th{width:50%}}@media (min-width:1000px){td:nth-last-child(3):first-child~td,td:nth-last-child(3):first-child~th,th:nth-last-child(3):first-child~td,th:nth-last-child(3):first-child~th{width:33.33333%}}@media (min-width:1000px){td:nth-last-child(4):first-child~td,td:nth-last-child(4):first-child~th,th:nth-last-child(4):first-child~td,th:nth-last-child(4):first-child~th{width:25%}}@media (min-width:1000px){td:nth-last-child(5):first-child~td,td:nth-last-child(5):first-child~th,th:nth-last-child(5):first-child~td,th:nth-last-child(5):first-child~th{width:20%}}@media (min-width:1000px){td:nth-last-child(6):first-child~td,td:nth-last-child(6):first-child~th,th:nth-last-child(6):first-child~td,th:nth-last-child(6):first-child~th{width:16.66667%}}@media (min-width:1000px){td:nth-last-child(7):first-child~td,td:nth-last-child(7):first-child~th,th:nth-last-child(7):first-child~td,th:nth-last-child(7):first-child~th{width:14.28571%}}@media (min-width:1000px){td:nth-last-child(8):first-child~td,td:nth-last-child(8):first-child~th,th:nth-last-child(8):first-child~td,th:nth-last-child(8):first-child~th{width:12.5%}}@media (min-width:1000px){td:nth-last-child(9):first-child~td,td:nth-last-child(9):first-child~th,th:nth-last-child(9):first-child~td,th:nth-last-child(9):first-child~th{width:11.11111%}}th{margin-top:1rem;border-top:4px solid #d2d2d2;border-bottom:1px solid #d2d2d2}tbody .category+.child>th{border-top:0;margin-top:0}@media (min-width:1000px){th{margin-top:0;border-top:0}}th[scope=row]{font-weight:inherit}td{padding:.5rem 1.125rem;border:0}@media (min-width:1000px){td{border-bottom:1px solid #d2d2d2}}@media (min-width:1000px){td,th{padding:1rem}}caption{border-bottom:3px solid #d2d2d2}.responsive-table--row-strategy thead{display:none}@media (min-width:1000px){.responsive-table--row-strategy thead{display:table-header-group}}.responsive-table--row-strategy td,.responsive-table--row-strategy th{display:block}@media (min-width:1000px){.responsive-table--row-strategy td,.responsive-table--row-strategy th{display:table-cell}}.responsive-table--row-strategy td:before,.responsive-table--row-strategy th:before{content:attr(data-label) ": ";font-weight:700}.responsive-table--row-strategy .category td:before,.responsive-table--row-strategy .category th:before{content:""}@media (min-width:1000px){.responsive-table--row-strategy td:before,.responsive-table--row-strategy th:before{content:none}}.responsive-table--column-strategy{display:none}@media (min-width:1000px){.responsive-table--column-strategy{display:table}}@media (min-width:1000px){.responsive-table__wrapper--column-strategy .responsive-table__mobile-alternative{display:none}}.responsive-table__wrapper--scroll-strategy{overflow-x:auto}@media (min-width:1000px){.responsive-table__wrapper--scroll-strategy{overflow:hidden}}:host([pfe-c-style=compact]) .lifecycle-table__product-name,:host([pfe-c-style=compact]) table{font-size:.875rem;line-height:1.5}:host([pfe-c-style=compact]) .product-lifecycle-info__table-headers{border:0}:host([pfe-c-style=compact]) caption,:host([pfe-c-style=compact]) td,:host([pfe-c-style=compact]) th{padding:.57143em}:host([pfe-c-style=compact]) caption:first-child,:host([pfe-c-style=compact]) td:first-child,:host([pfe-c-style=compact]) th:first-child{padding-left:1.14286em}:host([pfe-c-style=compact]) caption:last-child,:host([pfe-c-style=compact]) td:last-child,:host([pfe-c-style=compact]) th:last-child{padding-right:1.14286em}:host([pfe-c-style=compact]) th{border-top-width:2px;padding-top:.85714em}:host([pfe-c-style=compact]) caption{padding-top:1.14286em;border-bottom-width:1px}.toggle-arrow-default{float:left;cursor:pointer;margin-right:1rem}.toggle-arrow-composable{transform:rotate(-90deg)}.product-content-hidden{display:none}#plcc-footer-note p{white-space:pre-wrap}.header-icon-wrap,.version-icon-wrap{position:relative;text-align:left;cursor:pointer}.header-icon-wrap>svg,.version-icon-wrap>svg{position:absolute}.header-icon-wrap .tooltip,.version-icon-wrap .tooltip{display:none;width:250px;padding:10px;box-sizing:border-box;box-shadow:0 .5rem 1rem 0 rgba(3,3,3,.16),0 0 .375rem 0 rgba(3,3,3,.08);background-color:#fff;color:#151515;font-size:14px;word-wrap:break-word;z-index:2000;position:absolute;left:50%;bottom:160%;transform:translateX(-43%);transition:ease-in-out 1s}.header-icon-wrap a,.version-icon-wrap a{color:#06c}.header-icon-wrap .expand-arrow,.version-icon-wrap .expand-arrow{display:inline-block;width:120px;height:16px;position:absolute;top:-60%;left:-50px}.header-icon-wrap .tooltip::after,.version-icon-wrap .tooltip::after{display:none;content:"";border-width:8px 8px 8px 8px;border-style:solid;border-color:#fff transparent transparent transparent;position:absolute;left:44%;top:100%}.version-name-icon-wrap .tooltip{display:none;padding:10px;text-align:left;position:absolute;left:30%;bottom:160%;transform:translateX(-38%);transition:ease-in-out 1s;transition-delay:1s;box-shadow:0 .5rem 1rem 0 rgba(3,3,3,.16),0 0 .375rem 0 rgba(3,3,3,.08)}.version-name-icon-wrap .tooltip::after{display:none;content:"";border-width:8px 8px 8px 8px;border-style:solid;border-color:#fff transparent transparent transparent;position:absolute;left:39%;top:100%}.expand-arrow:hover .tooltip,.expand-arrow:hover .tooltip::after,.header-icon-wrap:hover .tooltip,.header-icon-wrap:hover .tooltip::after,.version-icon-wrap:hover .tooltip,.version-icon-wrap:hover .tooltip::after{display:block}
/*# sourceMappingURL=plcc-table.min.css.map */
</style><div id="loading" hidden>
  <pfe-progress-indicator></pfe-progress-indicator>
</div>
<article
  class="product-lifecycle__wrapper"
  id="product-lifecycle__wrapper--listing"
>
  <button
    class="product-lifecycle__close icon-close application"
    id="close-btn"
    aria-label="Closes Red Hat OpenStack Platform Table"
    hidden
  >
    <div class="icon-close__inner1"></div>
  </button>
  <h2 class="product-lifecycle-info__product-name sr-only"></h2>
  <div id="product-lifecycle-toggle-eol-checkbox">
    <input type="checkbox" name="toggle-eol" id="toggle-eol" />
    <label for="toggle-eol">Include unsupported versions</label>
  </div>

  <table
    id="product-lifecycle-table"
    border="0"
    cellspacing="0"
    cellpadding="0"
    class="product-lifecycle-info__table responsive-table responsive-table--row-strategy"
  >
    <thead class="product-lifecycle-info__table-headers">
      <tr id="product-table-phases"></tr>
    </thead>
    <tbody class="product-lifecycle-info__table_content"></tbody>
  </table>

  <p id="plcc-release-cadence"></p>
  <p id="plcc-former-names"></p>
  <div id="plcc-footer-note"></div>
  <p id="plcc-disclaimer"></p>
</article>`;
  }
  static get tag() {
    return "plcc-table";
  }

  static get events() {
    return {
      close: `${this.tag}:close`,
    };
  }

  static get properties() {
    return {
      _lang: {
        title: "Language support",
        attr: "lang",
        default: "en",
        type: String,
      },
      productName: {
        title: "Name of product required for api",
        attr: "product-name",
        type: String,
      },
      hideEol: {
        title: "Hide end-of-life section",
        attr: "hide-eol",
        type: Boolean,
        // observer: "_hideEolChange",
      },
      app: {
        title: "Toggle application version",
        attr: "app",
        type: String,
      },
      expandable: {
        title: "Toggle version category",
        attr: "expandable",
        default: false,
        type: Boolean,
      },
      toggleEOL: {
        title: "Toggle end-of-life checkbox",
        attr: "toggle-eol",
        type: Boolean,
        observer: "_toggleEolChange",
      },

      oplUuid: {
        title: "Unique identifier for OPL",
        attr: "opl-uuid",
        type: String,
      },
    };
  }

  static get slots() {
    return {};
  }

  get templateUrl() {
    return "plcc-table.html";
  }

  get styleUrl() {
    return "plcc-table.css";
  }

  get app() {
    return this.getAttribute("app");
  }

  get hideEOL() {
    return this.getAttribute("hide-eol");
  }

  get expandable() {
    return this.getAttribute("expandable");
  }

  get toggleEOL() {
    return this.getAttribute("toggle-eol");
  }

  get originRelative() {
    return this.hasAttribute("origin-relative");
  }

  get originPreviewPro() {
    return this.hasAttribute("origin-preview-pro");
  }

  get loading() {
    return this.hasAttribute("loading");
  }

  set loading(val) {
    if (val) {
      this._loadingIndicator.removeAttribute("hidden");
      this._loadingIndicator.classList.add("loading");
      this.setAttribute("loading", true);
    } else {
      this._loadingIndicator.setAttribute("hidden", true);
      this._loadingIndicator.classList.remove("loading");
      this.removeAttribute("loading");
    }
  }

  get tableData() {
    return this._data;
  }

  set tableData(data) {
    if (!data) {
      return;
    }

    this.loading = true;
    this._data = data;
    let displayHeaders = this._getDisplayHeaders(this._data);
    let displayPhases = this._getDisplayPhases(this._data);
    this._construct(this._data, displayHeaders, displayPhases);
    this.loading = false;
  }

  // Declare the type of this component
  static get PfeType() {
    return PFElement.PfeTypes.Component;
  }

  constructor() {
    super(PlccTable, { type: PlccTable.PfeType });

    this._handleBtnClick = this._handleBtnClick.bind(this);
    this._handleToggleArrowClick = this._handleToggleArrowClick.bind(this);

    this._data = null;
    this._fullSupport = false;
    this._maintenanceSupport = false;
    this._extendedSupport = false;
    this._uncategorized = false;
    this._endOfMaintenance = false;
    this._endOfLife = false;
    this._plccApplication = false;
    this._hasFormerNames = false;
    this._hasFooterNote = false;
    this._hasReleaseCadence = false;

    //translations for static strings
    this._translations = {
      en: {
        full_support: "Full Support",
        maint_support: "Maintenance Support",
        ext_support: "Extended Support",
        uncategorized: "Uncategorized",
        end_maintenance: "End of maintenance",
        end_life: "End of life",
        version: "Version",
        tier: "Tier",
        openShift_compatibility: "OpenShift Compatibility",
        releaseCadenceText: "Estimated release cadence: ",
        formerNamesText: "The former names of this product are: ",
        final_minor: "Final minor release",
        not_applicable: "N/A",
        disclaimer:
          "All future dates mentioned are close approximations, non definitive, and subject to change.",
      },
      ja: {
        full_support: "フルサポート",
        maint_support: "メンテナンスサポート",
        ext_support: "延長サポート",
        uncategorized: "未分類",
        end_maintenance: "メンテナンスサポートの終了日",
        end_life: "ライフサイクルの終了日",
        version: "バージョン",
        tier: "階層",
        openShift_compatibility: "OpenShift との互換性",
        releaseCadenceText: "推定されるリリース頻度: ",
        formerNamesText: "旧製品名: ",
        final_minor: "最終マイナーリリース",
        not_applicable: "該当なし",
        disclaimer:
          "記載されている将来の日付はすべて概算であり、決定的なものではなく、変更される可能性があります。",
      },
      ko: {
        full_support: "완전 지원",
        maint_support: "유지 관리 지원",
        ext_support: "연장 지원",
        uncategorized: "범주화되지 않음",
        end_maintenance: "유지 관리 지원 종료",
        end_life: "종료일",
        version: "버전",
        tier: "계층",
        openShift_compatibility: "OpenShift와의 호환성",
        releaseCadenceText: "예상되는 릴리스 빈도: ",
        formerNamesText: "이 제품의 이전 이름: ",
        final_minor: "마지막 마이너 릴리스",
        not_applicable: "해당 없음",
        disclaimer:
          "언급된 모든 향후 날짜는 확정되지 않은 예상 날짜이며 변경될 수 있습니다.",
      },
      zh_CN: {
        full_support: "完全支持",
        maint_support: "维护支持",
        ext_support: "延长的支持",
        uncategorized: "未分类",
        end_maintenance: "维护结束",
        end_life: "生命周期结束",
        version: "版本",
        tier: "层级",
        openShift_compatibility: "OpenShift 兼容性",
        releaseCadenceText: "预计发行节奏: ",
        formerNamesText: "此产品以前的名称: ",
        final_minor: "最后的次发行版本",
        not_applicable: "不适用",
        disclaimer:
          "所有提到的未来日期均为近似日期，未完全确定，可能随时更改。",
      },
      fr: {
        full_support: "Prise en charge complète",
        maint_support: "Assistance à la maintenance",
        ext_support: "Support étendu",
        uncategorized: "Non catégorisé",
        end_maintenance: "Fin de maintenance",
        end_life: "Fin de vie",
        version: "Version",
        tier: "Niveau",
        openShift_compatibility: "Compatibilité OpenShift",
        releaseCadenceText: "Cadence de sortie estimée : ",
        formerNamesText: "Les anciens noms de ce produit sont : ",
        final_minor: "Version mineure finale",
        not_applicable: "N/A",
        disclaimer:
          "Toutes les dates futures mentionnées sont des approximations non définitives et susceptibles d'être modifiées.",
      },
    };

    this._disclaimer = this.shadowRoot.querySelector("#plcc-disclaimer");
    this._article = this.shadowRoot.querySelector("article");
    this._lifecycleTable = this.shadowRoot.querySelector(
      "#product-lifecycle-table"
    );

    this._lifecycleTableBody = this.shadowRoot.querySelector(
      "#product-lifecycle-table tbody"
    );

    this._tablePhaseRow = this.shadowRoot.querySelector(
      "#product-table-phases"
    );

    this._closeBtn = this.shadowRoot.querySelector("#close-btn");
    this._loadingIndicator = this.shadowRoot.querySelector("#loading");

    this._formerNames = this.shadowRoot.querySelector("#plcc-former-names");

    this._toggleArrowBtnList = this.shadowRoot.querySelectorAll(
      ".toggle-arrow-default"
    );

    this._toggleEolCheckboxWrap = this.shadowRoot.querySelector(
      "#product-lifecycle-toggle-eol-checkbox"
    );

    this._toggleEolCheckbox = this.shadowRoot.querySelector("#toggle-eol");
    this._toggleEolCheckbox.addEventListener("change", (event) =>
      this._handleToggleEolCheckboxChange(event)
    );

    this._footerNote = this.shadowRoot.querySelector("#plcc-footer-note");
    this._releaseCadence = this.shadowRoot.querySelector(
      "#plcc-release-cadence"
    );
    this.loading = false;
  }

  connectedCallback() {
    super.connectedCallback();

    //check for lang attribute on html tag
    // if (document.querySelector("html").hasAttribute("lang")) {
    //   this._lang = document.querySelector("html").getAttribute("lang");
    // }
    //check for lang attribute from cookie
    let rh_locale_match = document.cookie.match(
      /rh_locale=(en|ja|ko|fr|zh_CN)/i
    );
    if (rh_locale_match && rh_locale_match[1]) {
      this._lang = rh_locale_match[1];
    }

    this._requestProduct();
  }

  disconnectedCallback() {
    this._closeBtn.removeEventListener("click", this._handleBtnClick);
  }

  _toggleEolChange() {
    this._handleToggleEOL(this.hasAttribute("toggle-eol"));
  }

  _requestProduct() {
    this.loading = true;

    let parameterList = [];

    if (this._lang && this._lang !== "en") {
      parameterList.push(`lng=${this._lang}`);
    }

    if (this.productName && this.productName !== "") {
      parameterList.push(`name=${this.productName}`);
    } else if (this.oplUuid) {
      parameterList.push(`opl-uuid=${this.oplUuid}`);
    } else {
      this.loading = false;
      return;
    }

    let origin = "https://access.redhat.com";
    if (this.originRelative) {
      origin = "";
    } else if (this.originPreviewPro) {
      origin = "https://access.qa.redhat.com";
    }

    const parameterStr = parameterList.join("&");
    const query = `${origin}/product-life-cycles/api/v1/products?${parameterStr}`;

    const promise = new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", query);
      xhr.responseType = "json";

      xhr.onload = () => {
        if (xhr.status >= 400) {
          reject(xhr.response);
        } else {
          resolve(xhr.response);
        }

        this.loading = false;
      };

      xhr.onerror = (err) => {
        reject(err, "Something went wrong.");
        this.loading = false;
      };

      xhr.send();
    })
      .then((data) => {
        this.tableData = data;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  _getDisplayHeaders(data) {
    let displayHeaders = [];
    if (data.data[0].is_operator) {
      displayHeaders.push(this._translations[this._lang].tier);
      if (data.data[0].show_openshift_compatibility)
        displayHeaders.push(
          this._translations[this._lang].openShift_compatibility
        );
    }
    if (data.data[0].is_layered_product) {
      displayHeaders = displayHeaders.concat(
        data.data[0].product_extra_headers
      );
    }

    return displayHeaders;
  }

  _getDisplayPhases(data) {
    const displayPhases = data.data[0].all_phases.map((item) => ({
      name: item.name,
      display_name: item.display_name,
      additional_text: item.additional_text || "",
    }));
    return displayPhases;
  }

  _getFormerNames(data) {
    let formerNames = "";
    if (data.data[0].former_names && data.data[0].former_names.length > 0) {
      formerNames = data.data[0].former_names.join(", ");
    }

    return formerNames;
  }

  _convertHyperlinkToHtml(hyperlinkString) {
    const regex1 = /\[(.*?)\]\((.*?)\)/g;
    const regex2 = /\[(.*?)\|(.*?)\]/g;
    const regex3 = /\[(.*?)\]/g;

    const resString = hyperlinkString.replace(regex1, ($0, $1, $2) => {
      return `<a href=${$2} target=_blank>${$1}</a>`;
    });
    const resString2 = resString.replace(regex2, ($0, $1, $2) => {
      return `<a href=${$2} target=_blank>${$1}</a>`;
    });

    const aHtmlString = resString2.replace(regex3, ($0, $1) => {
      return `<a href=${$1} target=_blank>${$1}</a>`;
    });

    return aHtmlString;
  }

  _encodeHTMLEntities(text) {
    let textArea = document.createElement("textarea");
    textArea.innerText = text;
    let encodedOutput = textArea.innerHTML;
    let arr = encodedOutput.split("<br>");
    encodedOutput = arr.join("\n");
    return encodedOutput;
  }

  _createQuestionIcon(tooltip, className, styleCss) {
    if (!tooltip) return "";
    const newToolTip = this._convertHyperlinkToHtml(
      this._encodeHTMLEntities(tooltip)
    );
    return `<span class="version-icon-wrap ${className}" style=${styleCss}>
    <span class="tooltip">${newToolTip}</span>
    <span class="expand-arrow"></span>
    <svg
    t="1684932112993"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2538"
    width="1.4em"
    height="1.4em"
    >
    <path
      d="M512 896a384 384 0 1 1 384-384 384.426667 384.426667 0 0 1-384 384z m0-718.72A334.72 334.72 0 1 0 846.72 512 335.146667 335.146667 0 0 0 512 177.28z m-27.52 520.362667a30.805333 30.805333 0 1 1 61.610667 0 30.805333 30.805333 0 0 1-61.610667 0z m29.781333-66.986667a24.661333 24.661333 0 0 1-24.661333-24.618667v-38.997333a92.586667 92.586667 0 0 1 41.088-76.202667c16.213333-9.386667 31.274667-20.821333 44.8-33.877333 13.141333-14.08 20.48-32.64 20.48-51.925333a80.298667 80.298667 0 0 0-82.133333-78.890667 78.250667 78.250667 0 0 0-82.133334 76.629333 24.661333 24.661333 0 1 1-49.28 0 130.816 130.816 0 0 1 261.418667 2.261334 125.866667 125.866667 0 0 1-34.304 86.186666c-16.938667 16.64-35.882667 31.104-56.448 42.965334-11.733333 6.357333-15.018667 27.093333-15.402667 33.877333v38.186667a24.661333 24.661333 0 0 1-23.466666 24.448z"
      fill="#000000"
      p-id="2539"
    ></path>
    </svg></span>`;
  }

  _createVersionName(item, versionName) {
    return `<th scope="row" data-label="${versionName}">
      ${item.name}${
      item.additional_text
        ? this._createQuestionIcon(
            item.additional_text,
            "version-name-icon-wrap"
          )
        : ""
    }
      </th>`;
  }

  _createVersionPhases(row, displayPhases, headers) {
    return row.phases
      .map((phase, pIndex) => {
        if (headers.includes(phase.name)) {
          return `<td data-label="${
            displayPhases[pIndex].display_name
          }"> ${this._parseDate(phase.date, phase.date_format)}
          ${this._parseSuperscript(phase.superscript)}
        ${this._createQuestionIcon(phase.additional_text, "version-icon-wrap")}
        </td>`;
        } else {
          return `<td data-label="${displayPhases[pIndex].display_name}">${
            this._translations[this._lang].not_applicable
          }</td>`;
        }
      })
      .join("");
  }

  _createTierOpenshiftCompatibility(
    item,
    isOperator,
    showOpenshiftCompatibilty
  ) {
    const tierTd = isOperator
      ? `<td data-label="${this._translations[this._lang].tier}">${
          item.tier
        }</td>`
      : "";
    const openshiftCompatibilityTd =
      isOperator && showOpenshiftCompatibilty
        ? `<td data-label="${
            this._translations[this._lang].openShift_compatibility
          }">${item.openshift_compatibility}</td>`
        : "";
    return `${tierTd}${openshiftCompatibilityTd}`;
  }

  _createVersionExtraHeaders(item, productExtraHeaders, noApplicable) {
    return item.extra_dependences
      .map((dependent_value, index) => {
        if (dependent_value !== null) {
          return `<td data-label="${productExtraHeaders[index]}">${dependent_value}</td>`;
        } else {
          return `<td data-label="${productExtraHeaders[index]}">${noApplicable}</td>`;
        }
      })
      .join("");
  }

  _createFinalMinorRelease(item, finalMinor, noApplicable) {
    return item.final_minor_release !== null
      ? `<td data-label="${finalMinor}">` + item.final_minor_release + "</td>"
      : `<td data-label="${finalMinor}">${noApplicable}</td>`;
  }

  _createVersionCategory(
    category,
    cellColSpan,
    versionType,
    className,
    productName
  ) {
    let isHiddenTr = false;
    if (this.hasAttribute("hide-eol") && versionType === END_OF_LIFE) {
      isHiddenTr = true;
    }
    let isExpandable = this.hasAttribute("expandable") ? true : false;

    return `
    <tr ${isHiddenTr ? "hidden" : ""} class="${className} category">
    <td scope="col" colSpan=${cellColSpan}>
      <div class="toggle-arrow-default toggle-arrow-expandable" ${
        isExpandable ? "" : "hidden"
      }>
        <svg
          style="vertical-align: -0.125em"
          fill="currentColor"
          height="1em"
          width="1em"
          viewBox="0 0 320 512"
          aria-hidden="true"
          role="img"
        >
          <path
            d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
          ></path>
        </svg>
      </div>
      <h3 class="lifecycle-table__product-name">${category} <span class="sr-only">${productName}</span></h3></td></tr>
    `;
  }

  //construct table headers and rows based on data and append to html
  _construct(data, displayHeaders, displayPhases) {
    let allFullSupportRows = "";
    let allMaintenanceSupportRows = "";
    let allExtendedSupportRows = "";
    let allEndOfLifeRows = "";
    let allEndOfMaintenanceRows = "";
    let versionName = this._translations[this._lang].version;
    let allHeaders = `<th scope="col">${versionName}</th>`;
    let versions = data.data[0].versions;
    let showMinor = data.data[0].show_final_minor_release;
    let layeredProduct = data.data[0].is_layered_product;
    let productExtraHeaders = data.data[0].product_extra_headers;
    let noApplicable = this._translations[this._lang].not_applicable;
    let finalMinor = this._translations[this._lang].final_minor;

    let formerNames = this._getFormerNames(data);
    let footerNote = data.data[0].footnote || "";
    let releaseCadence = data.data[0].release_cadence || "";
    let isOperator = data.data[0].is_operator;
    let show_openshift_compatibility =
      data.data[0].show_openshift_compatibility;

    let headers = data.data[0].all_phases.map((phase) => phase.name);
    if (layeredProduct) {
      headers = headers.concat(data.data[0].product_extra_headers);
    }

    if (releaseCadence !== "") {
      this._hasReleaseCadence = true;
      this.shadowRoot.querySelector("#plcc-release-cadence").textContent =
        this._translations[this._lang].releaseCadenceText + releaseCadence;
    }

    if (formerNames !== "") {
      this._hasFormerNames = true;
      this.shadowRoot.querySelector("#plcc-former-names").textContent =
        this._translations[this._lang].formerNamesText + formerNames;
    }

    if (footerNote !== "") {
      this._hasFooterNote = true;
      this.shadowRoot.querySelector("#plcc-footer-note").innerHTML = footerNote;
    }

    this._disclaimer.innerHTML = this._translations[this._lang].disclaimer;

    //set product name
    this.shadowRoot.querySelector(
      ".product-lifecycle-info__product-name"
    ).innerText = data.data[0].name;

    //create table headers
    displayHeaders.forEach((item) => {
      let theader = `<th scope="col">${item}</th>`;
      allHeaders += theader;
    });
    console.log(displayHeaders, 999);

    displayPhases.forEach((item) => {
      let theader = `<th scope="col">${
        item.display_name
      }${this._createQuestionIcon(
        item.additional_text,
        "header-icon-wrap"
      )}</th>`;
      allHeaders += theader;
    });

    //check if minor version column should display
    if (showMinor) {
      allHeaders += `<th scope="col">${
        this._translations[this._lang].final_minor
      }</th>`;
    }

    const versionCategories = [
      FULL_SUPPORT,
      MAINTENANCE_SUPPORT,
      EXTENDED_SUPPORT,
      END_OF_MAINTENANCE,
      END_OF_LIFE,
      UNCATEGORIZED,
    ];

    versionCategories.forEach((type) => {
      const matchVersions = versions.filter((v) => {
        if (!v.type) {
          return true;
        } else {
          return v.type === type;
        }
      });
      if (matchVersions.length > 0) {
        let className = "";
        if (type === FULL_SUPPORT) {
          className = FULL_SUPPORT_ClASS;
        } else if (type === MAINTENANCE_SUPPORT) {
          className = MAINTENANCE_SUPPORT_CLASS;
        } else if (type === EXTENDED_SUPPORT) {
          className = EXTENDED_SUPPORT_CLASS;
        } else if (type === END_OF_MAINTENANCE) {
          className = END_OF_MAINTENANCE_CLASS;
        } else if (type === END_OF_LIFE) {
          className = END_OF_LIFE_CLASS;
        }
        const isHiddenTr =
          this.hasAttribute("hide-eol") && type === END_OF_LIFE ? true : false;
        let versionRowStr = "";
        matchVersions.forEach((item) => {
          versionRowStr += `
        <tr class="${className} child" ${isHiddenTr ? "hidden" : ""}>
          ${this._createVersionName(item, versionName)}
          ${this._createTierOpenshiftCompatibility(
            item,
            isOperator,
            show_openshift_compatibility
          )}
          ${
            layeredProduct
              ? this._createVersionExtraHeaders(
                  item,
                  productExtraHeaders,
                  noApplicable
                )
              : ""
          }
          ${this._createVersionPhases(item, displayPhases, headers)}
            ${
              showMinor
                ? this._createFinalMinorRelease(item, finalMinor, noApplicable)
                : ""
            }
          </tr>
          `;
        });
        switch (type) {
          case FULL_SUPPORT:
            allFullSupportRows += versionRowStr;
            break;
          case MAINTENANCE_SUPPORT:
            allMaintenanceSupportRows += versionRowStr;
            break;
          case EXTENDED_SUPPORT:
            allExtendedSupportRows += versionRowStr;
            break;
          case END_OF_MAINTENANCE:
            allEndOfMaintenanceRows += versionRowStr;
            break;
          case END_OF_LIFE:
            allEndOfLifeRows += versionRowStr;
            break;
          // case UNCATEGORIZED:
          //   this._uncategorized = true;
          //   allUncategorizedRows += versionRowStr;
          //   break;
          default:
            break;
        }
      }
    });

    if (!this._hasReleaseCadence) {
      this._releaseCadence.setAttribute("hidden", true);
    } else {
      this._releaseCadence.removeAttribute("hidden");
    }

    if (!this._hasFormerNames) {
      this._formerNames.setAttribute("hidden", true);
    } else {
      this._formerNames.removeAttribute("hidden");
    }

    if (!this._hasFooterNote) {
      this._footerNote.setAttribute("hidden", true);
    } else {
      this._footerNote.removeAttribute("hidden");
    }

    this._tablePhaseRow.innerHTML = allHeaders;

    const cellColSpan =
      1 + displayHeaders.length + displayPhases.length + (showMinor ? 1 : 0);

    const fullSupport = this._translations[this._lang].full_support;
    const maintenanceSupport = this._translations[this._lang].maint_support;
    const extendedSupport = this._translations[this._lang].ext_support;
    const endOfMaintenance = this._translations[this._lang].end_maintenance;
    const endOfLife = this._translations[this._lang].end_life;
    const productName = data.data[0].name;

    const fullSupportStrs = allFullSupportRows
      ? this._createVersionCategory(
          fullSupport,
          cellColSpan,
          FULL_SUPPORT,
          FULL_SUPPORT_ClASS,
          productName
        ) + allFullSupportRows
      : "";

    const maintenSupportStrs = allMaintenanceSupportRows
      ? this._createVersionCategory(
          maintenanceSupport,
          cellColSpan,
          MAINTENANCE_SUPPORT,
          MAINTENANCE_SUPPORT_CLASS,
          productName
        ) + allMaintenanceSupportRows
      : "";

    const extendedSupportStrs = allExtendedSupportRows
      ? this._createVersionCategory(
          extendedSupport,
          cellColSpan,
          EXTENDED_SUPPORT,
          EXTENDED_SUPPORT_CLASS,
          productName
        ) + allExtendedSupportRows
      : "";

    const endOfLifeStrs =
      this._createVersionCategory(
        endOfLife,
        cellColSpan,
        END_OF_LIFE,
        END_OF_LIFE_CLASS,
        productName
      ) + allEndOfLifeRows;

    const endMaintenanceStrs = allEndOfMaintenanceRows
      ? this._createVersionCategory(
          endOfMaintenance,
          cellColSpan,
          END_OF_MAINTENANCE,
          END_OF_MAINTENANCE_CLASS,
          productName
        ) + allEndOfMaintenanceRows
      : "";

    this._lifecycleTableBody.innerHTML =
      fullSupportStrs +
      maintenSupportStrs +
      extendedSupportStrs +
      endMaintenanceStrs +
      endOfLifeStrs;

    this._handleVersionCategoryExpandable();
    this._handleToggleEolCheckboxShow();
  }

  //check for valid date
  _parseDate(date, format) {
    if (format === "string") {
      return date;
    } else {
      return `<pfe-datetime datetime=${date} day="numeric" month="long" year="numeric" time-zone="UTC" locale="${
        this._lang !== "zh_CN" ? this._lang : "zh-Hans-CN"
      }"></pfe-datetime>`;
    }
  }

  //check for superscript
  //only render the superscript if it's not in app and has superscript value
  _parseSuperscript(data) {
    if (!this.hasAttribute("app") && typeof data !== "undefined") {
      return `<sup>${data}</sup>`;
    } else {
      return "";
    }
  }

  _handleToggleEolCheckboxChange(event) {
    const child = this._lifecycleTableBody.children;

    if (event.currentTarget.checked) {
      for (let i = 0; i < child.length; i++) {
        if (child[i].className.includes(END_OF_LIFE_CLASS)) {
          child[i].removeAttribute("hidden");
        }
      }
    } else {
      for (let i = 0; i < child.length; i++) {
        if (child[i].className.includes(END_OF_LIFE_CLASS)) {
          child[i].setAttribute("hidden", true);
        }
      }
    }
  }

  _handleToggleEOL(val) {
    if (val) {
      this._toggleEolCheckboxWrap.removeAttribute("hidden");
    } else {
      this._toggleEolCheckboxWrap.setAttribute("hidden", true);
    }
  }

  _handleToggleEolCheckboxShow() {
    if (this.hasAttribute("toggle-eol")) {
      this._toggleEolCheckboxWrap.removeAttribute("hidden");
      if (!this.hasAttribute("hide-eol")) {
        this._toggleEolCheckbox.setAttribute("checked", true);
      }
    } else {
      this._toggleEolCheckboxWrap.setAttribute("hidden", true);
    }
  }

  //emit close button event
  _handleBtnClick(event) {
    this.emitEvent(PlccTable.events.close);
  }

  _handleVersionCategoryExpandable() {
    const arrowIconList = this._lifecycleTableBody.querySelectorAll(
      ".toggle-arrow-default"
    );

    if (this.hasAttribute("expandable")) {
      arrowIconList.forEach((item, index) => {
        item.setAttribute("index", index);
        item.addEventListener("click", this._handleToggleArrowClick);
      });
    } else {
      arrowIconList.forEach((item, index) => {
        item.setAttribute("hidden", true);
      });
    }
  }

  _handleToggleArrowClick(event) {
    const index = event.currentTarget.getAttribute("index");
    const arrowIconList = this._lifecycleTableBody.querySelectorAll(
      ".toggle-arrow-default"
    );
    const eleClassList = event.currentTarget.classList.value;

    const parentClass = arrowIconList[index].closest("tr").className;
    const parentList = this._lifecycleTableBody.querySelectorAll(
      `.${parentClass && parentClass.split(" ")[0]}`
    );

    if (!eleClassList.includes("toggle-arrow-composable")) {
      arrowIconList[index].classList.add("toggle-arrow-composable");
      parentList.forEach((item) => {
        if (item.className.includes("child")) {
          item.setAttribute("hidden", true);
        }
      });
    } else {
      arrowIconList[index].classList.remove("toggle-arrow-composable");
      parentList.forEach((item) => {
        item.removeAttribute("hidden");
      });
    }
  }
}

PFElement.create(PlccTable);

export default PlccTable;
